import React from "react";

import Button from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import useCrashFreeSessionsScoring from "@main/pages/Release/consumers/useCrashFreeSessionsScoring";
import { MetricScoreOutletContext } from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import { MetricRow } from "@main/pages/Release/views/MetricDetails/shared/MetricRow";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import { useOutletContext } from "react-router-dom";

import * as Styled from "./CrashFreeSessionsScoreView.styles";

export default function CrashFreeSessionsScoreView() {
  const { refetchReleaseStatus } = useOutletContext<MetricScoreOutletContext>();
  const { thresholdRows, scoringConfigLoading, handleSave, isSaving } =
    useCrashFreeSessionsScoring(refetchReleaseStatus);
  const hasThresholdError = thresholdRows.some((t) => Boolean(t.error));

  if (scoringConfigLoading) {
    return <Spinner />;
  }

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Score
        </Heading>

        <Paragraph>
          {"Feel free to fine-tune how the 'Crash-free sessions' score is calculated.\n" +
            "Within each range, the score interpolates linearly between adjacent thresholds. A value exactly halfway between two thresholds gives a score halfway between their assigned scores."}
        </Paragraph>

        <Styled.ThresholdList>
          {thresholdRows.map((row) => (
            <MetricRow
              key={row.score}
              description={row.description}
              value={row.value}
              error={row.error}
              onChange={row.onChange}
              score={row.score}
              unit={"%"}
              showScore
            />
          ))}
        </Styled.ThresholdList>

        <Button
          type="submit"
          size="small"
          disabled={hasThresholdError || isSaving}
          onClick={handleSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
